(function () {
  'use strict';
  if (window.falcxFormsInitialized) return;
  window.falcxFormsInitialized = true;

  function run() {
    if (new URLSearchParams(window.location.search).get('customer_posted') !== 'true') return;
    var target;
    try {
      target = decodeURIComponent(window.location.hash.slice(1));
    } catch (error) {
      return;
    }
    if (!target) return;
    var submittedForm = document.getElementById(target);
    if (!submittedForm || !submittedForm.querySelector('[data-falcx-form-success]')) return;
    document.querySelectorAll('[data-falcx-form-success]').forEach(function (message) {
      var form = message.closest('form');
      if (!form) return;
      var isSubmitted = form.id === target;
      message.hidden = !isSubmitted;
      var fields = form.querySelector('[data-falcx-form-fields]');
      if (fields) fields.hidden = isSubmitted;
    });
    var status = submittedForm.querySelector('[role="status"][data-falcx-form-success]');
    if (status && !status.dataset.falcxFocused) {
      status.setAttribute('tabindex', '-1');
      status.focus();
      status.dataset.falcxFocused = 'true';
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  document.addEventListener('shopify:section:load', run);
})();
